import axios from "axios";
import { useEffect, useState } from 'react';
import { api } from '../utils';

export default function useGetInstronInvalidSpecsLogged(props) {
  const [isLoading, setIsLoading] = useState(true);
  const [list, setList] = useState([]); 

  useEffect(() => {
    setIsLoading(true);
    const cancelToken = axios.CancelToken;
    const source = cancelToken.source();

    api.fetchS(`Quality/LoadEnterQualityTestDataGrid`, {}, source.token)
      .then(response => {
        if(response.data.success){
            setList(response.data.testResults);
        } else {
           throw new Error("There was an error in fetching InstronInvalidSpecsLogged, contact your admin...");
        }
      })
      .catch(api.catchHandler)
      .finally(() => setIsLoading(false));

      return () => { 
        source.cancel("axios request cancelled"); 
      };
  }, []);

  return [list, isLoading];
}